import { render, staticRenderFns } from "./swipe-nav-button.vue?vue&type=template&id=4f537c97&scoped=true&"
import script from "./swipe-nav-button.vue?vue&type=script&lang=ts&"
export * from "./swipe-nav-button.vue?vue&type=script&lang=ts&"
import style0 from "./swipe-nav-button.vue?vue&type=style&index=0&id=4f537c97&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f537c97",
  null
  
)

export default component.exports